import React, {
  Component,
} from "react";
import {
  Button,
} from "react-bootstrap";
import {
  Link,
} from "react-router-dom";
import {
  withLocation,
} from "CommonCore/router-util";
import store from "CommonState/store";
import Breadcrumb from "CommonComponents/breadcrumb";
import antragApi, {
  antragParams,
  vertragschema,
} from "Apis/antrag-api";
import EntityTable from "CommonComponents/entity-table";
import {
  createInjectsSelector,
  injectsFromSchemaAndRenderMethods,
} from "CommonCore/schema-util";
import Confirmation from "CommonComponents/confirmation";
import {
  formatMassnahme,
} from "Apis/massnahme-api";
import {
  ANTRAGSTELLERMODUS,
  antragtypBearbeitbar,
  ROLLEN,
  userPersonalrat,
  userSachbErweitert,
} from "App/constants";
import apifetch from "CommonCore/apifetch";
import {
  notifyPopup,
} from "CommonCore/util";
import {
  ifAllowed,
} from "CommonState/uiconfig";
import {
  getModus,
} from "App/antragsteller-modus";
import {
  derived, createUiListSelector,
} from "CommonState/action-helpers";
import {
  Spinner,
} from "CommonComponents/bricks";
import {
  VERTRAGSARTEN_SHK,
} from "./constants";
import _ from "lodash";

const TableRenderMethods = (modusAntrag = true) => {
  return {
    massnahmen: {
      inject: ["k_einrichtungLookup", "k_vertragsartLookup", "k_antragstypLookup"],
      generator: (a, b, c) => (array, obj) => {
        return obj && _.map(array, x => {
          return <p>{formatMassnahme(x, { k_einrichtungLookup: a, k_vertragsartLookup: b, k_antragstypLookup: c })}</p>;
        });
      },
    },
    a_nr: {
      generator: (item, obj) => obj && <Link to={`/${ modusAntrag ? "antrag" : "vertrag" }/${ obj.a_id }/deckblatt`}> {item} </Link>,
    },
  };
};

const antragUiListSelector = createUiListSelector("antragaktivList", antragApi.schema, derived(
  "antragaktiv",
  state => state.antragList,
  state => state.flag_antragstellermodus,
  state => state.user,
  (list, modus, user) => {
    if (!list) {
      return null;
    }

    if (user.ro_id == ROLLEN.ROLLE_ANTRAGSTELLER) {
      const m = ANTRAGSTELLERMODUS[modus];
      if (!m) {
        return null;
      }
      return m.filterAnträge(list);
    }
        // Für SB nicht nach Hilfskraft / Werkvertrag etc. filtern
    return list;
  },
));

const vertragUiListSelector = createUiListSelector("vertragList", antragApi.schema, derived(
  "vertrag",
  state => state.antragList,
  state => state.flag_antragstellermodus,
  state => state.user,
  (list, modus, user) => {
    if (!list) {
      return null;
    }

    if (user.ro_id == ROLLEN.ROLLE_ANTRAGSTELLER) {
      const m = ANTRAGSTELLERMODUS[modus];
      if (!m) {
        return null;
      }
      return m.filterAnträge(list);
    }
        // Für SB nicht nach Hilfskraft / Werkvertrag etc. filtern
    return list;
  },
));

@withLocation
@antragApi.actions
@antragApi.list(antragParams())
@store("currentAntragInflight", "user")
export class AntragZuständigkeitOk extends Component {
  constructor() {
    super();
    this.state = {};
  }

  async componentDidMount() {
    if (userSachbErweitert(this.props.user)) {
      notifyPopup("Zuständigkeit wurde gewechselt.");
      this.props.onClose();
    }

    const { item } = this.props;

    try {
      await apifetch("/api/shkantrag/antrag/verantwortlich", {
        method: "POST",
        body: { a_id: item.a_id },
      });
    } catch(err) {
      this.setState({
        errorMessage:
          (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
      });
    }
  }

  render() {
    const { item, currentAntragInflight: inflight } = this.props;
    const { errorMessage } = this.state;

    if (userSachbErweitert(this.props.user)) {
      // Aktion ohne Dialog
      return null;
    }

    return (
      <Confirmation
        header={errorMessage ? "Fehler bei Zuständigkeitswechsel" : "Zuständigkeit übernommen"}
        body={!errorMessage ? `Sie haben nun die Zuständigkeit des Antrages ${ item.a_nr } übernommen.` : "Die Zuständigkeit konnte nicht übernommen werden."}
        action='Ok'
        actionStyle='primary'
        inflight={inflight}
        onConfirm={this.onConfirm}
        errorMessage={errorMessage}
      />
    );
  }
  onConfirm = () => {
    // this.props.clearAntragList()
    this.props.onClose();
  };
}

@store("currentAntragInflight")
export class StatuswechselModal extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { items, onCancel, action } = this.props;
    const { deleteFailedMessage } = this.state;

    return (
      <Confirmation
        header='Status setzen'
        action='Status setzen'
        actionStyle='primary'
        onCancel={onCancel}
        onConfirm={this.onConfirm}
        errorMessage={deleteFailedMessage}
      >
        <span>
          Sind Sie sicher, dass Sie den Status {items.length == 1 ? " des Antrages" : `aller ${ items.length } Anträge`} auf
          <br /><br /><div style={{ textAlign: "center" }}><h4>{action.statuswechsel.asf_kbez}</h4></div>
          <br />setzen möchten?
        </span>
      </Confirmation>
    );
  }

  onConfirm = () => {
    const { items, action } = this.props;
    // Statuswechsel präparieren
    const endpoint = "/api/shkantrag/antrag/statuswechsel";
    function statuswechsel(items) {
      const promiseArray = _.map(items, item => apifetch(endpoint, {
        method: "POST",
        body: {
          a_id: item.a_id,
          asf_id: action.statuswechsel.asf_id,
        },
      }));
      return Promise.all(promiseArray);
    }
    // Nach Status-Setzen beenden
    statuswechsel(items).then(() => {
      this.props.onComplete();
    }).catch(err => {
      this.setState({
        deleteFailedMessage:
          (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
      });
    });
  };
}

const injects = injectsFromSchemaAndRenderMethods(antragApi.schema, TableRenderMethods());
const selectInjects = createInjectsSelector(injects);

@withLocation
@store(...injects, "antragtyp", "k_vertragsart", "currentAntragInflight", "antragListInflight", "user", "k_antragstatusLookup", "flag_antragstellermodus", antragUiListSelector, vertragUiListSelector)
@ifAllowed("page.antrag")
@antragApi.uiList(antragParams())
@antragApi.noCache
@antragApi.actions
export default class AntragListPage extends Component {
  constructor() {
    super();
    this.last_aid = null;
    this.state = {
      edits: {},
      roleType: undefined,
    };
  }

  componentDidMount() {
    getModus(this.props);
  }

  getMultiStatusWerte = async selectedItems => {
    if (selectedItems?.[0]?.a_id) {
      const a_id = selectedItems[0].a_id;
      if (_.isEmpty(this.state.multiStatusWerte) || this.top_aid != a_id) {
        this.top_aid = a_id; // oberste a_id merken
        const werte = await apifetch(`/api/shkantrag/antrag/moeglicherstatus/${ a_id }`);
        this.setState({ multiStatusWerte: werte.data });
      }
    }
  };

  async componentDidUpdate(prevProps) {
    const { user, uiAntragaktivList } = this.props;
    const { multiStatusWerte } = this.state;
    if (user && (user.ro_id == ROLLEN.ROLLE_GLEICHSTELLUNG || userPersonalrat(user))) {
      // Multistatuswechsel aktuell nur für GSB und PR
      if (!multiStatusWerte) {
        /*
         * Wenn Liste noch leer oder oberster Artrag sich ändert, Statuswerte neu ermitteln
         * Die Liste ist nur Platzhalter, darf aber nicht leer sein, weil sonst der Beginn-Button nicht erscheint
         */
        await this.getMultiStatusWerte([uiAntragaktivList?.items[0]]);
      }
    }

    if (prevProps.flag_antragstellermodus !== this.props.flag_antragstellermodus) {
      await getModus(this.props);
    }
  }

  render() {
    const {
      uiAntragaktivList,
      uiVertragList,
      route,
      location,
      user,
      antragListInflight,
    } = this.props;
    const {
      multiStatusWerte,
    } = this.state;

    const modusAntrag = location ? !location.pathname.startsWith("/vertrag") : true;

    const istSachb = user && userSachbErweitert(user);
    const istAst = user && user.ro_id == ROLLEN.ROLLE_ANTRAGSTELLER;
    const istGSB = user && user.ro_id == ROLLEN.ROLLE_GLEICHSTELLUNG;
    const istPR_TUV = user && user.ro_id == ROLLEN.ROLLE_PERSONALRAT_TUV;
    const istPR = user && userPersonalrat(user);
    const istGSBoPR = user && (istGSB || istPR);
    const istDez13 = user && (user.ro_id == ROLLEN.ROLLE_DEZ1_3 || user.ro_id == ROLLEN.ROLLE_AUSSENWIRTSCHAFT);

    const actions = antrag => {
      const array = [
        {
          display: "Anzeigen",
          icon: "eye",
          execute: a => `/${ modusAntrag ? "antrag" : "vertrag" }/${ a.a_id }`,
        },
      ];
      if (istSachb) {
        // -> Antrag löschen entfernt nach PBP-978
        if (antrag.a_sb_nid != user.n_id && antragtypBearbeitbar(antrag, user)) {
          array.push({
            display: "Zuständigkeit übernehmen",
            icon: "user-circle-o",
            component: AntragZuständigkeitOk,
          });
        }
      }
      return array;
    };

    const mySchema = _.cloneDeep(modusAntrag ? antragApi.schema : vertragschema);

    if (istPR) {
      // Schema für PR anpassen
      const liste = ["a_nr",
                     "v_anrede",
                     "n_name",
                     "n_vorname",
                     "a_fakultaet_eid",
                     "v_einrichtungsverantwortlich",
                     "ansprechpartner",
                     "plan_beginn",
                     "plan_ende",
                     "a_artid",
                     "a_katid",
                     "finanzierung",
                     "arbeitszeit",
                     "a_asid",
                     "anz_massnahmen"];
      const tableNeu = [];
      _.map(liste, name => tableNeu.push(mySchema.table.find(x => x.field == name)));
      mySchema.table = tableNeu;
      mySchema.table.find(x => x.field == "anz_massnahmen").initiallyHidden = true; // Anzahl einblendbar
    }

    if (istDez13) {
      // Schema für Dez 1.3 anpassen (Vorträge/Kolloquien)
      const liste = ["a_nr",
                     "a_eingangsdat",
                     "a_fakultaet_eid",
                     "v_einrichtungsverantwortlich",
                     "ansprechpartner",
                     "n_name",
                     "n_vorname",
                     "n_email",
                     "pbp_id",
                     "a_sb_nid",
                     "a_artid",
                     "plan_beginn",
                     "plan_ende",
                     "finanzierung",
                     "a_asid"];
      const tableNeu = [];
      _.map(liste, name => tableNeu.push(mySchema.table.find(x => x.field == name)));
      mySchema.table = tableNeu;
      mySchema.table.find(x => x.field == "ansprechpartner").display = "Maßnahme erstellt von";
    }

    if (istAst) {
      mySchema.table = mySchema.table.filter(f => f.field != "finanzierung");
    }
    if (!istGSBoPR) {
      mySchema.table = mySchema.table.filter(f => f.field != "arbeitszeit");
    }

    let multiActions = null;
    let beforeMultiItemMode = null;
    let afterMultiItemMode = null;

    const checkDisabled = selectedItems => {
      // Massenstatuswechsel nur für Anträge mit gleichem Status und gleicher Vertragsart erlauben.
      const status = _.uniqBy(selectedItems, x => x.a_asid);
      const vertragsarten = _.uniqBy(selectedItems, x => x.a_artid);
      return _.isEmpty(status) || status.length > 1 || _.isEmpty(vertragsarten) || vertragsarten.length > 1;
    };

    const disabledInfo = selectedItems => {
      // Grund für das Sperren der Multiitem-Actions als Text liefern
      if (!selectedItems?.length) {
        return "Noch keine selektiert";
      }
      const status = _.uniqBy(selectedItems, x => x.a_asid);
      if (status.length > 1) {
        return "Nicht möglich, wenn verschiedene Statuswerte selektiert sind";
      }
      const vertragsarten = _.uniqBy(selectedItems, x => x.a_artid);
      if (vertragsarten.length > 1) {
        return "Nicht möglich, wenn verschiedene Vertragsarten selektiert sind";
      }
      return "";
    };


    if (istGSBoPR && !istPR_TUV && !_.isEmpty(multiStatusWerte)) {
      multiActions = _.map(multiStatusWerte, record => {
        return {
          display: record.asf_kbez,
          component: StatuswechselModal,
          statuswechsel: record, // Custom-Property zur Info an Popup
          checkDisabled: checkDisabled,
        };
      });

      beforeMultiItemMode = async() => {
        const { k_vertragsart } = this.props;
        this.lastFilter = await this.props.getUiListFilters("antragaktivList");
        // Filter setzen auf die SHK-Vertragsarten
        const args = [{ field: "a_artid", criteria: _.map(_.filter(k_vertragsart, x => VERTRAGSARTEN_SHK.indexOf(x.art_id) >= 0), x => x.art_kbez) }];
        await this.props.replaceUiListFilter("antragaktivList", args);
      };

      afterMultiItemMode = async() => {
        // Filter zurücksetzen
        await this.props.replaceUiListFilter("antragaktivList", this.lastFilter);
      };
    }

    return (
      <div>
        <Breadcrumb name={modusAntrag ? "Anträge" : "Abgeschlossene Verträge"} route={route} />
        {(modusAntrag && uiAntragaktivList) || (!modusAntrag && uiVertragList) ?
          <EntityTable
            list={modusAntrag ? "antragaktivList" : "vertragList"}
            data={modusAntrag ? uiAntragaktivList : uiVertragList}
            schema={mySchema}
            beforeMultiItemMode={beforeMultiItemMode}
            afterMultiItemMode={afterMultiItemMode}
            renderMethods={TableRenderMethods(modusAntrag)}
            multiItemActions={multiActions}
            onSelectionChanged={this.getMultiStatusWerte}
            multiItemStartTitle='Auswahl für Massenstatuswechsel'
            multiItemDropDownTitle='Statuswechsel für gewählte Anträge'
            afterMultiItemAction={this.afterStatuswechsel}
            multiItemDisabledInfo={disabledInfo}
            injects={selectInjects(this.props)}
            actions={actions}
            overrideInflight={antragListInflight}
          /> :
          <Spinner />}
      </div>
    );
  }

  afterStatuswechsel = async(action, cancelled) => {
    if (!cancelled) {
      // Reload auslösen
      await this.props.retrieveAntragList();
      this.forceUpdate();
    }
  };
}

/*
 *@antragApi.actions
 *@store('currentAntragInflight')
 *class AntragLoeschen extends Component {
 *  constructor() {
 *    super();
 *    this.state = {};
 *  }
 *
 *  render() {
 *    const { item, onClose, currentAntragInflight: inflight } = this.props;
 *    const { deleteFailedMessage } = this.state;
 *
 *    return (
 *      <Confirmation
 *        header='Antrag löschen'
 *        body={`Sind Sie sicher, dass Sie den Antrag ${item.a_nr} unwiderruflich löschen möchten?`}
 *        action='Löschen'
 *        inflight={inflight}
 *        onCancel={onClose}
 *        onConfirm={this.onConfirm}
 *        errorMessage={deleteFailedMessage}
 *      />
 *    );
 *  }
 *
 *  onConfirm = async () => {
 *    const { item, deleteAntrag } = this.props;
 *    try {
 *      await deleteAntrag(item.a_id);
 *    } catch (err) {
 *      this.setState({
 *        deleteFailedMessage:
 *          (err.response && (err.response.nachricht || err.response.um))
 *          || 'Es ist ein Fehler aufgetreten.'
 *      });
 *    }
 *    this.props.onClose();
 *  }
 *}
 */

@withLocation
export class GoToButton extends React.Component {
  render() {
    const {
      name,
    } = this.props;
    return <Button variant='outline-primary' onClick={this.navigate}>
      {name}
    </Button>;
  }
  navigate = () => {
    const { history, to } = this.props;
    history.push(to);
  };
}
